import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);

  // Verificar si la URL es la experiencia VR
  if (state.url.includes('/experience/vr')) {
    return true; // Permitir acceso sin importar el estado de autenticación
  }

  if (!authService.isTokenValid()) {
    authService.logout();
    return false;
  } else {
    return true;
  }
  
};
